'use client';

import { useEffect } from 'react';
import { initClientErrorCapture } from '@/core/lib/logger';

/**
 * LoggerProvider — installs global error handlers on mount.
 * Captures window.onerror, unhandledrejection, and resource errors,
 * then ships them to /api/log for persistence to disk.
 *
 * Renders nothing — pure side-effect component.
 */
export function LoggerProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initClientErrorCapture();
  }, []);

  return <>{children}</>;
}
